export const superAdminConstants = {
  GET_ORGANIZATIONS_REQUEST: "GET_ORGANIZATIONS_REQUEST",
  GET_ORGANIZATIONS_SUCCESS: "GET_ORGANIZATIONS_SUCCESS",
  GET_ORGANIZATIONS_FAILURE: "GET_ORGANIZATIONS_FAILURE",
};
